/**
 * <g-card> - Kanban Card
 *
 * A draggable card for use inside g-column.
 * Supports any HTML content as children.
 *
 * @example
 * <g-card card-id="task-123">
 *   <strong>Task Title</strong>
 *   <p>Description</p>
 * </g-card>
 *
 * @attr {string} card-id - Unique identifier (required for events)
 */
export class GCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    // Use Tailwind classes for background and border
    this.classList.add('bg-base-100', 'border', 'border-base-300');

    // Apply other styles inline
    this.style.display = 'block';
    this.style.borderRadius = '0.5rem';
    this.style.padding = '0.875rem';
    this.style.marginBottom = '0.5rem';
    this.style.cursor = 'grab';
    this.style.transition = 'box-shadow 0.15s ease, transform 0.15s ease';
    this.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';

    // Add hover effect via event listeners (only once)
    if (!this._hoverBound) {
      this._hoverBound = true;
      this.addEventListener('mouseenter', () => {
        this.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
        this.style.transform = 'translateY(-2px)';
      });
      this.addEventListener('mouseleave', () => {
        this.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';
        this.style.transform = 'none';
      });
    }
  }
}

customElements.define('g-card', GCard);
